import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  items: [], //  actual cart items for UI
  cartIds: [], // cart item IDs to send in payload
  shipping_id: null,
  billing_id: null,
  payment_method: "",
  company_name: "",
  gstin_number: "",
  pan_number: "",
  is_company: false,
  points: false,
  wallet: false,
  credit: false,
  promocode: "",
  buyNowData: {},
  skipPaymentPopup: false,
};
const CartSlice = createSlice({
  name: "cart",
  initialState,

  reducers: {
    //  Update item logic to use state.items
    add: (state, action) => {
      const existingItem = state.items.find(
        (item) => item.id === action.payload.id
      );
      if (!existingItem) {
        state.items.push({
          ...action.payload,
          quantity: action.payload.quantity || 1,
          selectedColor: action.payload.selectedColor,
          totalPrice: action.payload.sell_price,
        });
        state.cartIds.push(action.payload.id);
      }
    },

    remove: (state, action) => {
      state.items = state.items.filter((item) => item.id !== action.payload.id);
    },

    increment: (state, action) => {
      const item = state.items.find((item) => item.id === action.payload.id);
      if (item) {
        item.quantity += 1;
        item.totalPrice = item.quantity * item.sell_price;
      }
    },

    decrement: (state, action) => {
      const item = state.items.find((item) => item.id === action.payload.id);
      if (item && item.quantity > 1) {
        item.quantity -= 1;
        item.totalPrice = item.quantity * item.sell_price;
      }
    },

    setCartItems: (state, action) => {
      if (!Array.isArray(action.payload)) {
        throw new Error("🚨 Expected array in setCartItems");
      }

      state.items = action.payload; // ✅ Save full cart data for UI
      state.cartIds = action.payload.map((item) => item.id); // ✅ Extract IDs for payload
    },

    // clearBuyNowData: (state) => {
    //   state.buyNowData = null;
    // },
    setBuyNowData: (state, action) => {
      state.buyNowData = action.payload;
    },
    clearBuyNowData: (state) => {
      state.buyNowData = null;
    },

    setShippingId: (state, action) => {
      state.shipping_id = action.payload;
    },
    setBillingId: (state, action) => {
      state.billing_id = action.payload;
    },
    setPaymentMethod: (state, action) => {
      state.payment_method = action.payload;
    },
    setCompanyDetails: (state, action) => {
      const { company_name, gstin_number, pan_number, is_company } =
        action.payload;
      state.company_name = company_name;
      state.gstin_number = gstin_number;
      state.pan_number = pan_number;
      state.is_company = is_company;
    },
    setWallet: (state, action) => {
      state.wallet = action.payload;
    },
    setPoints: (state, action) => {
      state.points = action.payload;
    },
    setPromocode: (state, action) => {
      state.promocode = action.payload;
    },
    setCredit: (state, action) => {
      state.credit = action.payload;
    },
    setSkipPayment: (state, action) => {
      state.skipPaymentPopup = action.payload;
    },
    setDefaultCartData: (state, action) => {
      return initialState;
    },
  },
});

export const {
  add,
  remove,
  increment,
  decrement,
  setCartItems,
  setShippingId,
  setBillingId,
  setPaymentMethod,
  setSkipPayment,
  setCompanyDetails,
  setWallet,
  setPoints,
  setCredit,
  setPromocode,
  clearBuyNowData,
  setBuyNowData,
  setDefaultCartData,
} = CartSlice.actions;

export default CartSlice.reducer;
